import React, { useState } from "react";
import {
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Nav, NavItem,
	NavbarToggler,
	NavbarBrand,
	DropdownToggle
} from "reactstrap";
import { NavLink } from "react-router-dom";

import { topBarIcons } from "img/icons";
import styles from "./header.module.scss";


export default function Header(props) {
	const { logout, project, user, changeProject } = props;
	const [projectsOpen, setProjectsOpen] = useState(false)
	const [isOpen, setIsOpen] = useState(false)

	function collapse() {
		setIsOpen(a => !a)
	};


	function toggleProjects() {
		setProjectsOpen(a => !a)
	};

	function sidebarMinimize(e) {
		e.preventDefault();
		document.body.classList.toggle("sidebar-minimized");
	}

	function mobileSidebarToggle(e) {
		e.preventDefault();
		document.body.classList.toggle("sidebar-mobile-show");
	}

	function asideToggle(e) {
		e.preventDefault();
		document.body.classList.toggle("aside-menu-hidden");
	}

	let largeScreenMenu = (projectName, username, logout) => <Nav className={`ml-auto d-md-down-none ${styles.topmenu}`} navbar>
		<NavItem className={styles.navItem}>
			<Dropdown isOpen={projectsOpen} toggle={toggleProjects}>
				<DropdownToggle className="nav-link dropdown-toggle">
					<img
						src={topBarIcons.venue}
						className={styles.icon} alt=""/>
					<span className={`d-md-down-none ${styles.text}`}>{projectName}</span>
				</DropdownToggle>
				<DropdownMenu right className={projectsOpen ? "show" : ""}>
					{user.projects && user.projects.length < 5 && user.projects.map(p =>
						<DropdownItem key={p.id} onClick={() => changeProject(p)}>
							<NavLink to={"dashboard"}>{p.name}</NavLink>
						</DropdownItem>
					)}
					<DropdownItem onClick={() => changeProject()}>
						<NavLink to={"/"}>{"Vedi progetti"}</NavLink>
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		</NavItem>
		<NavItem className={styles.navItem}>
			<NavLink to={"profile"}>
				<img
					src={topBarIcons.profile}
					className={styles.icon} alt=""
				/>
				<span className={`d-md-down-none ${styles.text}`}>{username}</span>
			</NavLink>
		</NavItem>
		<NavItem className={styles.navItem}>
			<NavLink to={"manual"}>
				<img
					src={topBarIcons.manual}
					className={styles.icon} alt=""
				/>
				<span className={`d-md-down-none ${styles.text}`}>Manuali</span>
			</NavLink>
		</NavItem>
		<NavItem className={styles.navItem} onClick={logout}>
			<img
				src={topBarIcons.logOut}
				className={styles.icon} alt=""
			/>
			<span className={`d-md-down-none ${styles.text}`}>{"Logout"}</span>
		</NavItem>
	</Nav>;

	let mobileMenu = (username, logout) =>
		<Nav className={`ml-auto d-lg-none  ${styles.topmenu}`} navbar>
			<NavItem className={styles.navItem}>
				<Dropdown isOpen={isOpen} toggle={collapse}>
					<DropdownToggle className="nav-link dropdown-toggle">
						<img
							src={topBarIcons.venue}
							className={styles.icon} alt=""
						/>
					</DropdownToggle>
					<DropdownMenu right className={projectsOpen ? "show" : ""}>
						<DropdownItem
							id={"proj-button"}
							onClick={() => changeProject()}>
							<NavLink to={"/"}>
								<img
									src={topBarIcons.venue}
									className={styles.icon} alt=""
								/>
								<span className={`${styles.text}`}>{"Cambia progetto"}</span>
							</NavLink>
						</DropdownItem>
						<DropdownItem
							id={"profile-button"}
							onClick={null}>
							<NavLink to={"profile"}>
								<img
									src={topBarIcons.profile}
									className={styles.icon} alt=""
								/>
								<span className={`${styles.text}`}>{username}</span>
							</NavLink>
						</DropdownItem>
						<DropdownItem
							id={"manual-button"}
							onClick={null}>
							<NavLink to={"manual"}>
								<img
									src={topBarIcons.manual}
									className={styles.icon} alt=""
								/>
								<span className={`${styles.text}`}>Manuali</span>
							</NavLink>
						</DropdownItem>
						<DropdownItem
							id={"logout-button"}
							onClick={logout}>
							<img
								src={topBarIcons.logOut}
								className={styles.icon} alt=""
							/>
							<span className={`${styles.text}`}>{"Logout"}</span>
						</DropdownItem>
					</DropdownMenu>
				</Dropdown>
			</NavItem>
		</Nav>;

		let username = user ? `${user.firstName} ${user.lastName}` : "Nome Utente";
		let projectName = project ? project.name : "Nome Progetto";

	return (
		<header className="app-header navbar">
			<NavbarToggler className="d-md-down-none burger-button"
							onClick={sidebarMinimize}>&#9776;</NavbarToggler>
			<NavbarToggler className="d-lg-none menu-top-left"
							onClick={mobileSidebarToggle}>&#9776;</NavbarToggler>
			<NavbarBrand href="https://www.waiv.it" target="_blank"/>

			{largeScreenMenu(projectName, username, logout)}

			{mobileMenu(username, logout)}
		</header>
	)
}

// Header.propTypes = {
//   logout: PropTypes.func.isRequired,
//   project: PropTypes.object,
//   user: PropTypes.object,
//   changeProject: PropTypes.func
// };

// Header.defaultProps = {
//   project: null,
//   user: null,
//   changeProject: () => {}
// };
